exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-style[data-v-67250fb2] .ui.selection.dropdown .menu{max-height:150px}", ""]);

// exports
